import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { makeSelectFormData, makeSelectStep } from '@/model/withdrawal/selectors';
import { TransactionFields } from '@/pages/withdrawal/pages/StatusPage/components/ResultFields/types';

const selectStatus = makeSelectStep();
const selectFormData = makeSelectFormData();

export default function useResultFields(): TransactionFields | undefined {
  const withdrawal = useSelector(selectFormData);
  const { sbpId } = useSelector(selectStatus);
  return useMemo(
    () =>
      withdrawal
        ? {
            isFPS: !!sbpId,
            sbpId,
            id: withdrawal.id,
            person: withdrawal.receiver,
            amount: -1 * Math.abs(withdrawal.amount?.value || 0),
            bank: withdrawal.bank?.value ? { id: withdrawal.bank.value } : undefined,
            wallet: withdrawal.wallet?.value,
            message: withdrawal.message?.value,
            fee: withdrawal.fee,
            createdAt: withdrawal.createdAt,
          }
        : undefined,
    [withdrawal, sbpId],
  );
}
